<ng-template let-item #menuItem>
  <ng-container *ngIf="item.menuItem.children?.length; else simpleMenuItem">
    <ng-container
      *ngTemplateOutlet="
        expandableMenuItem;
        context: {
          $implicit: { menuItem: item.menuItem, level: item.level }
        }
      "
    ></ng-container
  ></ng-container>
  <ng-template #simpleMenuItem>
    <a
      mat-list-item
      [routerLink]="item.menuItem.routerLink"
      [appIfHasRoles]="item.menuItem.userRole"
      class="sidenav-list-item menu-level-{{ item.level }}"
      [disabled]="item.menuItem.isDisabled ? true : null"
      (click)="onMenuItem($event)"
    >
      {{ item.menuItem.title | translate }}
    </a>
  </ng-template>
</ng-template>

<ng-template #expandableMenuItem let-item>
  <mat-expansion-panel
    class="white"
    [@.disabled]="footer"
    [hideToggle]="item.level === 0"
    [appIfHasRoles]="item.menuItem.userRole"
    [id]="item.menuItem.rootUrl"
    [class.first-level]="item.level === 0"
    #expPanels
  >
    <mat-expansion-panel-header
      #expansionPanelHeader
      (click)="onPanel($event, item, expansionPanelHeader)"
      class="menu-level-{{ item.level }}"
      [class.active]="
        item.level === 0 && router.url.includes(item.menuItem.rootUrl)
      "
    >
      <mat-panel-title class="sidenav-list-item">
        {{ item.menuItem.title | translate }}
      </mat-panel-title>
    </mat-expansion-panel-header>
    <ul class="ul-level-{{ item.level }}">
      <li
        *ngFor="let childItem of item.menuItem.children"
        [appIfHasRoles]="childItem.userRole"
      >
        <ng-container
          *ngTemplateOutlet="
            menuItem;
            context: {
              $implicit: { menuItem: childItem, level: item.level + 1 }
            }
          "
        ></ng-container>
      </li>
    </ul>
  </mat-expansion-panel>
</ng-template>

<mat-nav-list>
  <ul class="root-list">
    <li *ngFor="let item of menuItems" class="root-menu">
      <ng-container
        *ngTemplateOutlet="
          menuItem;
          context: { $implicit: { menuItem: item, level: 0 } }
        "
      ></ng-container>
    </li>
  </ul>
</mat-nav-list>
